module.exports = __webpack_public_path__ + "assets/img/page5-nav-item-8-4f20c4bc.png";